/**
 * Sortable, collision-resistant ids.
 *
 * Lexicographic order matches creation order, which lets IndexedDB range
 * queries over a key double as "most recent first" without a separate index.
 * Format: 10 chars of base32 timestamp (ms) + 16 chars of base32 randomness.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford base32, no I/L/O/U

function encodeTime(ms: number, len: number): string {
  let out = '';
  let n = ms;
  for (let i = len - 1; i >= 0; i--) {
    out = ALPHABET[n % 32] + out;
    n = Math.floor(n / 32);
  }
  return out;
}

function randomChars(len: number): string {
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < len; i++) out += ALPHABET[bytes[i]! % 32];
  return out;
}

/** A new sortable id. */
export function newId(at: number = Date.now()): string {
  return encodeTime(at, 10) + randomChars(16);
}

/** Recover the creation time encoded in an id. */
export function idTime(id: string): number {
  let n = 0;
  for (let i = 0; i < 10; i++) {
    const idx = ALPHABET.indexOf(id[i] ?? '');
    if (idx < 0) return NaN;
    n = n * 32 + idx;
  }
  return n;
}
